import React from "react";
import "./shimmer.css";
export const Shimmer = ({ width = "100%", height = "20px", borderRadius = "16px" }) => {
    return (React.createElement("div", { className: "shimmer-wrapper", style: { width, height, borderRadius } },
        React.createElement("div", { className: "shimmer-animation" })));
};
